module.exports = __webpack_public_path__ + "095af85d8dc1edefaca727e3d77fa0a6.svg";